import React, { SVGProps } from "react";

const ChevronUp: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.44445 6.78933C1.07755 7.10383 0.52516 7.06134 0.210666 6.69443C-0.103827 6.32752 -0.0613365 5.77513 0.305573 5.46064L6.43056 0.210649C6.75824 -0.0702171 7.24176 -0.0702171 7.56944 0.210649L13.6944 5.46064C14.0613 5.77513 14.1038 6.32752 13.7893 6.69443C13.4748 7.06134 12.9225 7.10383 12.5555 6.78933L7 2.02744L1.44445 6.78933Z"
      fill={props.color || "white"}
    />
  </svg>
);

export default ChevronUp;
